import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

export const PrimitiveWrapper = styled.span(({ theme }) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing.xxSmall,
}));

export const PrimitiveIcon = styled(Image)({
    objectFit: "contain",
    flexShrink: 0,
    position: "relative",
    top: "2px",
});

export const PrimitiveButton = styled(Text)({
    background: "transparent",
    border: "none",
    padding: 0,
    margin: 0,
    cursor: "pointer",
    display: "inline",
});
